__turbopack_context__.v({
  "band": "Chart-module__JCzpMq__band",
  "bars": "Chart-module__JCzpMq__bars",
  "chartArea": "Chart-module__JCzpMq__chartArea",
  "column": "Chart-module__JCzpMq__column",
  "seg": "Chart-module__JCzpMq__seg",
  "segGreen": "Chart-module__JCzpMq__segGreen",
  "segPer": "Chart-module__JCzpMq__segPer",
  "segPro": "Chart-module__JCzpMq__segPro",
  "segRed": "Chart-module__JCzpMq__segRed",
  "segStack": "Chart-module__JCzpMq__segStack",
  "tick": "Chart-module__JCzpMq__tick",
  "tickRow": "Chart-module__JCzpMq__tickRow",
});
